import React, { useRef } from "react";
import { useReduxState } from "../../../explorer/redux/hooks";
import { reduxStoreConfig } from "../../configuration/reduxStoreConfig";
import ServiceProvider from "../../configuration/ServiceProvider";
import { Site } from "../../../explorer/types/SpareParts/Site";
import { Basket } from "../../../explorer/types";
import useCurrentSite from "../../hook/useCurrentSite";
import { useLocation, useMatch } from "react-router";
import useBrands from "../../../explorer/hooks/useBrands";
import { useBasket } from "../../hook/useBasket";

export const AppContextProvider: React.FC<any> = (
  props: React.PropsWithChildren<any>
) => {
  // Qui viene caricata la parte di SpareParts
  // Aggiungere qui in futuro parti non System, esempio Accessori

  const location = useLocation();
  const match = useMatch(":context/:brand/site/:customerSiteCode/*");
  const [sites, setSites] = useReduxState<Site[]>(
    reduxStoreConfig.sparePartsSites
  );
  // const [baskets, setBaskets] = useReduxState<Basket[]>(
  //   reduxStoreConfig.basketBaskets
  // );
  const brand = useBrands().currentBrandUrl;
  const [currentSite, setCurrentSite] = useCurrentSite();
  const [currentSiteRedux, setCurrentSiteRedux] = useReduxState<Site>(reduxStoreConfig.sparePartsCurrentSite);
  // const [currentBasket, setCurrentBasket] = useReduxState<Basket>(
  //   reduxStoreConfig.basketCurrentBasket
  // );
  const sitesBrand = useRef<string>();
  const basketBrand = useRef<string>();
  const basketOperation = useBasket();

  React.useEffect(() => {
    if (brand !== sitesBrand.current) {
      ServiceProvider.SpareParts.getSites(brand)
        .then((result) => {
          setSites(result);
          setCurrentSiteRedux({});
          sitesBrand.current = brand;
        })
        .catch((e) => console.error(e));
    }

    if (basketBrand.current !== brand) {
      // ServiceProvider.Basket.getBaskets(brand)
      //   .then((result) => {
      //     setBaskets(result);
      //     setCurrentBasket(result.find((x) => x.selected)!);
      //     basketBrand.current = brand;
      //   })
      //   .catch((e) => console.error(e));
      basketOperation.reloadBaskets(brand);
    }
  }, [brand]);

  React.useEffect(() => {
    //if (!sites || sites.length === 0) return;
    retrieveCurrentSite();
  }, [location, sites]);

  React.useEffect(() => {
    //if (!sites || sites.length === 0) return;
    //retrieveCurrentSite();
  }, [currentSite]);

  const retrieveCurrentSite = () => {
    const customerSiteCode = match?.params.customerSiteCode;
    // se esite il parametro vince sul resto, ma va verificato che sia un site valido
    if (customerSiteCode !== undefined && customerSiteCode !== null) {
      let _currentSite: Site | undefined = getValidSite(customerSiteCode);
      // se esiste il parametro ed e' un site esistente, allora lo setto
      if (_currentSite) {
        if (
          Object.keys(currentSite).length === 0 ||
          currentSite.customerSiteCode !== _currentSite.customerSiteCode
        ) {
          setCurrentSite(_currentSite);
        }
      } else {
        // prendo il primo site
        setFirstSite();
      }
    } else {
      if (Object.keys(currentSite).length === 0) {
        getCurrentSiteService((currSite) => {
          if (currSite && Object.keys(currSite).length !== 0) {
            let _currentSite: Site | undefined = getValidSite(
              currSite.customerSiteCode!
            );
            if (_currentSite) setCurrentSiteRedux(currSite);
            else setFirstSite();
          } else {
            setFirstSite();
          }
        });
      }
    }
  };

  const setFirstSite = () => {
    if (sites && sites.length > 0) {
      setCurrentSite(sites[0]);
    }
  };

  const getValidSite: (siteCode: string) => Site | undefined = (
    siteCode: string
  ) => {
    return sites?.filter(
      (site) => site.customerSiteCode?.toLowerCase() === siteCode.toLowerCase()
    )[0];
  };

  const getCurrentSiteService = (callback: (currSite: Site) => void) => {
    ServiceProvider.SpareParts.getCurrentSite(brand)
      .then((result) => {
        callback(result);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  return <>{props.children}</>;
};
